import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { isServedFromCache } from "../lib/api";

// Shown while the service worker is answering from the phone's saved copy
// (no signal). Clears itself on the first live response.
export default function OfflineDataBanner() {
  const [offline, setOffline] = useState(isServedFromCache);
  useEffect(() => {
    const on = (e) => setOffline(!!e.detail);
    window.addEventListener("tow-offline-data", on);
    return () => window.removeEventListener("tow-offline-data", on);
  }, []);
  if (!offline) return null;
  return (
    <div
      className="mb-4 px-4 py-3 rounded-md bg-slate-100 dark:bg-slate-800/60 border border-slate-300 dark:border-slate-600 flex items-center gap-3"
      data-testid="driver-offline-data-banner"
    >
      <WifiOff className="h-5 w-5 text-slate-600 dark:text-slate-300 shrink-0" />
      <p className="text-sm font-semibold text-slate-700 dark:text-slate-200">
        No signal — showing your jobs as last saved on this phone. Photos and updates still save and send when signal returns.
      </p>
    </div>
  );
}
